/**
 *
 *
 *
 */

import { createLog } from "../../util/log";

export type EphemeralFirstLevelValues = Record<string, string[]>;

const log = createLog("state");

/*                                                                                  */
let pendingValues: EphemeralFirstLevelValues = {};

/*                                                                                                            */
export const ephemeralFirstLevelValues = $state<{ values: EphemeralFirstLevelValues }>({ values: {} });

/**
 *
 *
 */
export function savePendingEphemeralOrder(filterId: string, values: string[]) {
  if (!pendingValues[filterId]) {
    log.debug("pending first level order saved", { filterId, values });
    pendingValues[filterId] = values;
  } else {
    log.debug("pending first level order ignored: first change wins until the next reload", { filterId });
  }
}

/**
 *
 *
 */
export function commitEphemeralOrder() {
  if (Object.keys(pendingValues).length > 0) {
    log.debug("pending first level orders committed", { filterIds: Object.keys(pendingValues) });
    ephemeralFirstLevelValues.values = { ...ephemeralFirstLevelValues.values, ...pendingValues };
    pendingValues = {};
  }
}

export function clearEphemeralFirstLevelValues() {
  log.debug("first level orders cleared");
  ephemeralFirstLevelValues.values = {};
  pendingValues = {};
}
